'use client'

import { clsx } from 'clsx'
import { type FC, type PropsWithChildren, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../../generic-hooks'

interface ProductDescriptionShowMoreProps extends PropsWithChildren {
  defaultOpen?: boolean
}

export const ProductDescriptionShowMore: FC<
  ProductDescriptionShowMoreProps
> = ({ children, defaultOpen = false }) => {
  const { handleOpen, isOpen } = useOpenableControls(defaultOpen)
  const maxHeightInPx = 320

  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const scrollHeight = containerRef.current?.scrollHeight ?? 0
    if (scrollHeight < maxHeightInPx) {
      handleOpen()
    }
  }, [handleOpen])

  return (
    <div
      className={clsx(!isOpen && 'relative max-h-[320px] overflow-hidden')}
      ref={containerRef}
    >
      {children}
      {isOpen ? null : (
        <div className="absolute bottom-0 w-full">
          <div className="absolute -top-10 h-10 w-full bg-gradient-to-t from-light-primary-low" />
          <div className="bg-light-primary-low pt-3.5 text-center">
            <Button onClick={handleOpen} variant="outlined">
              <FormattedMessage id="general.label.showMore" />
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
